module.exports = __webpack_public_path__ + "static/media/GT-America-Condensed-Regular.b179147b.woff";